import React from 'react'
import { pathDiseaseDetail } from './pathDiseaseDetail'

function DiseaseList({ data, className = '' }) {
  return (
    <div className={className}>
      {data.map((node, index) => (
        <div className="col-12 col-lg-6" key={index}>
          <a href={pathDiseaseDetail(node)}>
            <div className="search_box">
              <h3>{node.title}</h3>
              <p>{node.summary}</p>
            </div>
          </a>
        </div>
      ))}
    </div>
  )
}

export { DiseaseList }
